var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-badge",style:(_vm.colorStyles)},[_c('span',{staticClass:"info-badge__background",style:({ backgroundColor: _vm.color })}),(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }